import { localStorageKey } from "@/configs/enum";
import _ from "lodash";
import { getWithExpiry } from "./helper";
import type { UserInformation } from "@/apis/register/type";

function getUserInfo(): UserInformation {
  const response = getWithExpiry<UserInformation>(
    localStorageKey.REGISTER_USER_INFORMATION,
  );

  if (response && !_.isEmpty(response?.data)) {
    const { data } = response;
    return {
      userId: data?.userId,
      roleId: data?.roleId,
      title: data?.title,
      prefix: data?.prefix,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      identityCard: data?.identityCard,
      personsId: data?.personsId,
      organizationId: data?.organizationId,
      roleName: data?.roleName,
      roleCode: data?.roleCode,
      tokenSarabun: data?.tokenSarabun,
      tokenSSO: data?.tokenSSO,
      fullName: data?.fullName,
    };
  }
  return {};
}

function getToken() {
  const userInfo = getWithExpiry(localStorageKey.REGISTER_USER_INFORMATION);
  const token = userInfo?.data?.token;
  if (!_.isEmpty(userInfo) && !!token) return token;
  return null;
}

function authenticated() {
  const token = getToken();
  return !!token;
}

function isNominationCommittee() {
  const userInfo = getUserInfo();
  if (!userInfo || userInfo?.roleCode !== "R017") return false;
  return true;
}

export { authenticated, getToken, getUserInfo, isNominationCommittee };
